import { InjectionToken } from '@angular/core';
import { LogLevel } from './logger.types';

export type LoggerConfig = {
  activeLogLevels: Set<LogLevel>;
};

export const LOGGER_CONFIG = new InjectionToken<LoggerConfig>('LoggerConfig', {
  providedIn: 'root',
  factory: () => ({ activeLogLevels: new Set<LogLevel>(['WARN', 'ERROR']) }),
});
